
// const req_token = ""//请求token
// const u_token = ""//账号登录token
import { getToken } from '@/utils/auth'
const resToken = ''
// const is_Token ='',
// const http = 'http://localhost:8080/'
const httpauto = 'https://login.bjadks.com/Auth/CheckLoginState?productId=10&redirectUrl=' // 免登录
const httplogin = 'https://login.bjadks.com/Auth/Login?bodyClass=szykt&redirectUrl=' // 登錄
const httpregist = 'https://login.bjadks.com/Register?bodyClass=szykt&redirectUrl=' // 注册
const httploginout = 'https://login.bjadks.com/Auth/Logout?redirectUrl=' // 退出
const httpcompany = 'https://login.bjadks.com/Auth/CompanyLoginAsToken?comId=' // 集团免登录
const userBase = null
const http = 'https://sz.bjadks.com/'

function formatDateYMD (time) {
  var datatime = time.replace(/\-/g, '/')
  datatime = datatime.replace('T', ' ')
  const dates = new Date(datatime)
  const year = dates.getFullYear()
  const month = dates.getMonth() + 1
  const date = dates.getDate()
  const day = dates.getDay()
  const hour = dates.getHours()
  const min = dates.getMinutes()
  const days = ['日', '一', '二', '三', '四', '五', '六']
  return {
    allDate: `${year}-${strFormat(month)}-${strFormat(date)}`,
    date: `${strFormat(month)}-${strFormat(date)}`, // 返回的日期 07-01
    day: `星期${days[day]}`, // 返回的礼拜天数  星期一
    hour: strFormat(hour) + ':' + strFormat(min), // 返回的时钟 08:00
    allDatatime: `${year}-${strFormat(month)}-${strFormat(date)}` + '  ' + strFormat(hour) + ':' + strFormat(min)

  }
}
function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  // console.log("获取cookie,现在循环"+ document.cookie)
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    // console.log(c)
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
  // return 'F00B1701307632BA0CFE2DACCB957D9A47C31DC5D155F5EB347F7881D7465F287363A4B3B5959FD474E8B8EE5173720F1623E29E2A2C8663C9A3CE10F6C88ED0C10092BF94F74C21DBA29C5C0AFBF884E57F5D3FAFF7986132315E73C98BF18D519538FA1CAE4F059F2CFF5B265EB46E05424227955C7CAF4D07C606361157B57FE155717F74870343ED5B0790BD38308C97AE65436DC360D84B7BBC471DB56515691F911AE4D241EEBE082A9110CB0EF6F0C52094AC1B84765C353F30FDFDA5'
}
// 字符串拼接
function strFormat (str) {
  return str < 10 ? `0${str}` : str
}
// const cate_fr =
//   [
// { "Id": 0, "CatalogName": "首页", "ParentId": 0, "Level": 1, "Order": 1000 },
// { "Id": 1042, "CatalogName": "0-3岁", "ParentId": 0, "Level": 1, "Order": 1042 },
// { "Id": 1043, "CatalogName": "3-6岁", "ParentId": 0, "Level": 1, "Order": 1043 },
// { "Id": 1044, "CatalogName": "6-15岁", "ParentId": 0, "Level": 1, "Order": 1044 },
// { "Id": 1045, "CatalogName": "老师", "ParentId": 0, "Level": 1, "Order": 1045 },
// { "Id": 1046, "CatalogName": "家长", "ParentId": 0, "Level": 1, "Order": 1046 },
// { "Id": 1047, "CatalogName": "绘本馆", "ParentId": 0, "Level": 1, "Order": 1047 },
// { "Id": 1048, "CatalogName": "电子书城", "ParentId": 0, "Level": 1, "Order": 1048 },
// { "Id": 1049, "CatalogName": "互动乐园", "ParentId": 0, "Level": 1, "Order": 1049 },
// { "Id": 1050, "CatalogName": "中小学微课堂", "ParentId": 0, "Level": 1, "Order": 1050 },
// { "Id": 2940, "CatalogName": "阅读指导", "ParentId": 0, "Level": 1, "Order": 2940 },
// { "Id": 3054, "CatalogName": "精品乐园", "ParentId": 0, "Level": 1, "Order": 3054 }
// ]
export default {

  http,
  userBase,
  resToken,
  httpauto,
  httplogin,
  httploginout,
  httpregist,
  httpcompany,
  getCookie,
  // is_Token,
  formatDateYMD
}
//   < script >
// var token = '';
// var resToken = "";
// var http = "http://localhost:8080/"
// const userBase = null
// // var http = "https://sz.bjadks.com/"
// var header = '';

// function formatDateYMD (time) {

//   var datatime = time.replace(/\-/g, "/")
//   var datatime = datatime.replace("T", " ")
//   const dates = new Date(datatime)
//   const year = dates.getFullYear()
//   const month = dates.getMonth() + 1
//   const date = dates.getDate()
//   const day = dates.getDay()
//   const hour = dates.getHours()
//   const min = dates.getMinutes()
//   const days = ['日', '一', '二', '三', '四', '五', '六']
//   return {
//     allDate: `${year}-${strFormat(month)}-${strFormat(date)}`,
//     date: `${strFormat(month)}-${strFormat(date)}`, //返回的日期 07-01
//     day: `星期${days[day]}`, //返回的礼拜天数  星期一
//     hour: strFormat(hour) + ':' + strFormat(min), //返回的时钟 08:00,
//     allDatatime: `${year}-${strFormat(month)}-${strFormat(date)}` + "  " + strFormat(hour) + ':' + strFormat(min)
//   }
// }
// //字符串拼接
// function strFormat (str) {
//   return str < 10 ? `0${str}` : str
// }
// export default {
//   listData,
//   token,

//   http,
//   resToken,
//   formatDateYMD

// }
// </script >



// WEBPACK FOOTER //
// ./src/utils/common.js